// extracted by mini-css-extract-plugin
export var button = "_hg-2";
export var card = "_hg-0";
export var closeButtonContainer = "_hg-3";
export var iconContainer = "_hg-1";